import React, { FunctionComponent } from "react";
import FormText from "reactstrap/lib/FormText";
import Input from "reactstrap/lib/Input";
import Label from "reactstrap/lib/Label";
import { Error } from "../Error";

export interface INumberProps {
  onChange?: (e?: any) => any;
  isValid?: boolean;
  infoMessage?: string;
  label?: string;
  name?: string;
  value?: number;
  placeholder?: string;
  errorMessage?: string;
  min?: number;
  max?: number;
  required?: boolean;
}

export const NumberInput: FunctionComponent<INumberProps> = (
  props: INumberProps
) => {
  return (
    <Label className="w-100">
      {props.label ? props.label : null}
      <Input
        className="mb-2 mt-1"
        onChange={props.onChange}
        value={props.value || undefined}
        name={props.name || undefined}
        placeholder={props.placeholder || undefined}
        type="number"
        min={props.min}
        max={props.max}
        required={props.required}
        // style={{ backgroundColor: '#ebecf1', borderRadius: '10px' }}
      />
      {props.infoMessage ? (
        <FormText color="muted">{props.infoMessage}</FormText>
      ) : null}
      {props.isValid === false ? <Error>{props.errorMessage}</Error> : null}
    </Label>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/input/Number.tsx